<template>
  <v-container>
    <v-row class="text-center">
      <v-col class="my-4">
        <h2 class="text-h3 text-sm-h2 mb-3 rapscall">
          Welcome to NB-Nova
        </h2>
      </v-col>
    </v-row>

    <v-lazy v-model="isActive" :options="{
      threshold: .8
    }" min-height="200" transition="fade-transition">

      <v-row class="text-center">
        <v-col class="mb-5" cols="12">
          <h2 class="mb-3">
            事業内容
          </h2>
        </v-col>

        <v-col v-for="(business, i) in businesses" :key="i" cols="12" md="6" lg="4">
          <v-card>
            <router-link :to="business.href">
              <v-img :src="business.src" max-height="300"></v-img>
            </router-link>
            <v-card-title>
              {{business.title}}
            </v-card-title>
            <v-card-text>{{business.description}}</v-card-text>
          </v-card>
        </v-col>
      </v-row>

    </v-lazy>
  </v-container>
</template>

<script>
export default {
  name: 'HelloWorld',

  data: () => ({
    businesses: [
      {
        title: '厳選中古車',
        description:'JDMをはじめ厳選した中古車をピックアップ',
        href: '/stocks',
        src: require('@/assets/stocks/Mark2/1.jpg'),
      },
      {
        title: 'Sennheiser',
        description:'ドイツの音響機器メーカー"Sennheiser"の高品質なヘッドセット各種の取り扱い',
        href: '/sennheiserPromo',
        src: require('@/assets/sennheiser/IMG_9448_1.png'),
      },
    ],
    isActive: false,
  }),
}
</script>
